import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate',
})
export class CustomDatePipe implements PipeTransform {
  transform(value: string | undefined, format = 'mediumDate'): string | null {
    if (!value) {
      return null;
    }
    const monthsMap: { [key: string]: string } = {
      ene: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      abr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      ago: 'Aug',
      sep: 'Sep',
      sept: 'sept',
      oct: 'Oct',
      nov: 'Nov',
      dic: 'Dec',
    };

    const dateParts = value.split('/');
    if (dateParts.length !== 3) {
      return null;
    }

    const day = dateParts[0];
    const month = monthsMap[dateParts[1].toLowerCase()];
    const year = dateParts[2];

    if (!month) {
      return null;
    }

    const dateStr = `${day} ${month} ${year}`;
    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      return null;
    }
    const datePipe = new DatePipe('es-MX');
    return datePipe.transform(date, format);
  }
}
